"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPopper = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const material_1 = require("@mui/material");
const ui_theme_1 = require("@kyruus/ui-theme");
const MUIPopperComponent = (0, ui_theme_1.withMuiThemeAdapter)(material_1.Popper);
const PopperComponent = (props) => (react_1.default.createElement(MUIPopperComponent, Object.assign({}, props)));
PopperComponent.displayName = 'Popper';
exports.StyledPopper = (0, styled_1.default)(PopperComponent) `
  > .MuiTooltip-tooltip {
    border: solid 1px ${(0, ui_theme_1.fromTheme)('color_info')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_info')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};

    > .MuiTooltip-arrow {
      color: ${(0, ui_theme_1.fromTheme)('color_info')};
    }
  }
`;
//# sourceMappingURL=styles.js.map